export default function () {
    return {
        template: require('./tag-list.html'),
        controller,
        controllerAs: 'tagListView'
    };

    function controller(tagSwitchService, getAllEnquiryTags, deleteTag, $stateParams) {
        const vm = this;

        vm.tags = [];

        vm.removeTag = removeTag;
        vm.addFlag = addFlag;

        tagSwitchService.subscribe('load-list', () => {
            vm.model = {};
            loadTags();
        });

        function addFlag() {
            tagSwitchService.publish('load-create');
        }

        function loadTags() {
            return getAllEnquiryTags($stateParams.vehicleId).then(response => {
                vm.tags = response;
            });
        }

        function removeTag(tagId) {
            deleteTag($stateParams.vehicleId, tagId).then(() => {
                tagSwitchService.publish('load-list');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/tagListDirective.js